<template>
  <div class="w-full">
    <WysiwygTextField
      v-model="draftText"
      :autofocus="true"
      :compact="true"
      :placeholder="$t('common.addText')"
      :is-always-expanded="true"
    />
    <div class="mt-4 flex w-full flex-row justify-between gap-0.5">
      <template v-if="!showDeleteDialog">
        <BaseIconButton
          v-tooltip="$t('common.deleteText')"
          v-if="canDelete"
          icon="delete"
          size="M"
          color="outlined"
          @click="showDeleteDialog = true"
        />
        <div v-else></div>
        <div class="flex flex-row gap-1">
          <BaseIconButton
            class="hidden lg:flex"
            icon="close"
            size="M"
            color="outlined"
            @click="emits('close')"
          />
          <BaseTextButton size="M" color="filled" @click="emits('save')">{{
            $t('common.addText')
          }}</BaseTextButton>
        </div>
      </template>
      <template v-else>
        <BaseTextButton size="M" @click="showDeleteDialog = false">{{
          $t('common.cancel')
        }}</BaseTextButton>
        <BaseTextButton
          size="M"
          icon="delete"
          color="filled"
          @click="emits('delete')"
          class="bg-error! text-on-error!"
          >{{ $t('common.delete') }}</BaseTextButton
        >
      </template>
    </div>
  </div>
</template>
<script lang="ts" setup>
  import BaseIconButton from '@/core/components/base/button/icon-button/BaseIconButton.vue'
  import BaseTextButton from '@/core/components/base/button/text-button/BaseTextButton.vue'
  import WysiwygTextField from '@/core/components/base/wysiwyg/WysiwygTextField.vue'
  import type { JSONContent } from '@tiptap/vue-3'
  import { ref } from 'vue'

  interface Props {
    canDelete: boolean
  }

  defineProps<Props>()

  const emits = defineEmits<{
    save: []
    delete: []
    close: []
  }>()

  const draftText = defineModel<JSONContent | undefined>({ required: true })

  const showDeleteDialog = ref(false)
</script>
